<template>
  <layout-card-wrap
    v-loading="loading"
    hasSlot>
    <template slot="title">考生信息</template>
    <div slot="form">
      <el-dropdown>
        <el-button
          type="primary"
          style="margin-right: 10px;">
          下载模板<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadtemplate">下载报名模板</el-dropdown-item>
          <el-dropdown-item
            :disabled="!(info.status === 7)"
            @click.native="downloadexamscoretemplate">下载成绩导入模板</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        type="primary"
        :disabled="![5,6].includes(info.status)"
        @click="uploadUser">导入名单</el-button>
      <el-button
        type="primary"
        :disabled="!(info.status === 7)"
        @click="uploadResult">导入成绩</el-button>
    </div>
    <el-form
      label-position="top"
      label-width="110px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="通过人数：">{{ info.passingCount }}人</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="参加人数：">{{ info.examineeCount }}人</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="报名：">{{ info.registrationCount }}人</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeName">
      <el-tab-pane
        label="报名信息"
        name="1">
        <student-reg-table
          :id="id"
          ref="reg" />
      </el-tab-pane>
      <el-tab-pane
        label="考生成绩"
        name="2">
        <student-score-table
          :id="id"
          ref="score"
          :info="info" />
      </el-tab-pane>
    </el-tabs>
    <upload-new ref="uploadNew" />
  </layout-card-wrap>
</template>
<script>
import UploadNew from '../../../../components/upload-new.vue'
import StudentRegTable from './student-reg-table.vue'
import StudentScoreTable from './student-score-table.vue'
import { downloadBlobFile } from '../../../../utils/index'
export default {
  name: 'ExamRegInfo',
  components: { StudentRegTable, StudentScoreTable, UploadNew },
  props: {
    callback: Function,
    id: { type: [Number, null], default: null },
    info: { type: Object, default() { return {} } }
  },
  data() {
    return {
      loading: false,
      activeName: '1'
    }
  },
  methods: {
    downloadexamscoretemplate() {
      this.loading = true
      this.$$examApi.downloadexamscoretemplate({ examId: this.info.id })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    downloadtemplate() {
      this.loading = true
      this.$$examApi.downloadexamregistrationtemplate({ })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    uploadUser() {
      this.$refs.uploadNew.upload({ examId: this.id }, (formData) => {
        this.$$examApi.uploadexamregistration(formData)
          .then(res => {
            this.loading = false
            const { result, message } = res.data
            if ([0].includes(result)) {
              this.$message.success('上传成功')
              this.$refs.reg.getlist()
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
      })
    },
    uploadResult() {
      this.$refs.uploadNew.upload({ examId: this.id }, (formData) => {
        this.$$examApi.uploadexamrscore(formData)
          .then(res => {
            this.loading = false
            const { result, message } = res.data
            if ([0].includes(result)) {
              this.$message.success('上传成功')
              this.$refs.score.getlist()
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
      })
    }
  }
}
</script>
